import { apiClient } from './client';

/**
 * 대화방 투표 (chat-polls — 2026-08-26).
 *
 * 투표를 만들면 서버가 대화에 메시지도 함께 남긴다(`[투표] 질문`). 화면은 방의 투표 목록을 받아
 * `messageId → 투표` 로 맞춰 그 자리에 카드를 그린다 — 메시지 형식은 한 칸도 늘리지 않았다.
 */

export interface PollOptionTally {
  id: string;
  text: string;
  count: number;
}

export interface Poll {
  id: string;
  roomId: string;
  /** 대화에 남은 메시지. 화면이 이 값으로 카드 자리를 찾는다. */
  messageId: string | null;
  createdBy: string;
  question: string;
  multi: boolean;
  anonymous: boolean;
  closesAt: string | null;
  closed: boolean;
  createdAt: string;
  voterCount: number;
  options: PollOptionTally[];
  /** 내가 고른 항목. 익명이어도 나에게는 돌려준다. */
  myOptionIds: string[];
}

export async function listRoomPolls(roomId: string): Promise<Poll[]> {
  const { data } = await apiClient.get<{ polls: Poll[] }>(`/chat/rooms/${roomId}/polls`);
  return data.polls ?? [];
}

export async function createPoll(roomId: string, input: {
  question: string;
  options: string[];
  multi?: boolean;
  anonymous?: boolean;
  closesAt?: string | null;
}): Promise<Poll> {
  const { data } = await apiClient.post<{ poll: Poll }>(`/chat/rooms/${roomId}/polls`, input);
  return data.poll;
}

/** 고른 것으로 통째로 바꾼다. 빈 배열이면 표를 거둔다. */
export async function votePoll(pollId: string, optionIds: string[]): Promise<Poll> {
  const { data } = await apiClient.post<{ poll: Poll }>(`/chat/polls/${pollId}/vote`, { optionIds });
  return data.poll;
}

/** 만든 사람 또는 방장만. */
export async function closePoll(pollId: string): Promise<Poll> {
  const { data } = await apiClient.post<{ poll: Poll }>(`/chat/polls/${pollId}/close`, {});
  return data.poll;
}
